var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 11C7 10.4688 7.4375 10 8 10H16C16.5312 10 17 10.4688 17 11V15C17 15.5625 16.5312 16 16 16H8C7.4375 16 7 15.5625 7 15V11ZM15.5 11.5H8.5V14.5H15.5V11.5ZM21 9V11.5C20.1562 11.5 19.5 12.1875 19.5 13C19.5 13.8438 20.1562 14.5 21 14.5V17C21 18.125 20.0938 19 19 19H5C3.875 19 3 18.125 3 17V14.5C3.8125 14.5 4.5 13.8438 4.5 13C4.5 12.1875 3.8125 11.5 3 11.5V9C3 7.90625 3.875 7 5 7H19C20.0938 7 21 7.90625 21 9ZM4.5 10.4062C5.375 10.9375 6 11.9062 6 13C6 14.125 5.375 15.0938 4.5 15.625V17C4.5 17.2812 4.71875 17.5 5 17.5H19C19.25 17.5 19.5 17.2812 19.5 17V15.625C18.5938 15.0938 18 14.125 18 13C18 11.9062 18.5938 10.9375 19.5 10.4062V9C19.5 8.75 19.25 8.5 19 8.5H5C4.71875 8.5 4.5 8.75 4.5 9V10.4062Z",
    fill: "#0D3338"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/Ticket.cdef8352a99e40eff5c28ce80ae8ce5d.svg";
export { ForwardRef as ReactComponent };